import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel } from '@mui';
import Switch from '@material-ui/core/Switch';
import './switch-label.scss';

export const SwitchLabel = memo(({ icon, label, toggled, onToggle, disabled, ...other }) => {
  if (icon) {
    return (
      <div styleName="toggle-root">
        <div styleName="small-toggle">
          <Switch
            checked={toggled}
            onChange={onToggle}
            disabled={disabled}
            color="primary"
            size="small"
            title={label}
            {...other}
          />
        </div>
        <div styleName="toggle-icon"> {icon} </div>
        <div styleName="toggle-label"> {label} </div>
      </div>
    );
  }
  return (
    <div styleName="toggle-root">
      <FormControlLabel
        styleName="toggle"
        control={
          <Switch
            checked={toggled}
            onChange={onToggle}
            disabled={disabled}
            color="primary"
            size="small"
            {...other}
          />
        }
        label={label}
        disabled={disabled}
      />
    </div>
  );
});

SwitchLabel.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.string,
  onToggle: PropTypes.func,
  toggled: PropTypes.bool
};

export default SwitchLabel;
